// NIP format: XXX XX XX XXX (spaces after 3rd, 5th and 7th digit)
export const formatNIP = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10) return value;
  return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7, 10)}`;
};

// Bank account (NRB) format: XX XXXX XXXX XXXX XXXX XXXX XXXX (26 digits with spaces)
export const formatAccountNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 26) return value;
  return [
    digits.slice(0, 2),
    digits.slice(2, 6),
    digits.slice(6, 10),
    digits.slice(10, 14),
    digits.slice(14, 18),
    digits.slice(18, 22),
    digits.slice(22, 26),
  ].join(" ");
};
